import { el } from '../lib/dom.js';

export function TypeChip(type) {
  return el('span', { class: 'type-chip', dataset: { type }, title: type }, type);
}
